import filter from 'lodash/filter';

import { QALITY_TEST_ISSUE_TYPE } from '@qality/common-config/src/constants';
import { IssueType } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

export default {
  //** DO NOT USE DIRECTLY ON CLOUD, ON SERVER ARRAY HAS LENGTH 0 OR 1 */
  async getTestCaseIssueTypes(): Promise<Array<IssueType>> {
    const issuetypeResponse = await StorageOfUniqueServices.get('API').request(
      '/rest/api/2/issuetype'
    );
    const issueTypes = JSON.parse(issuetypeResponse.body);
    return filter(
      issueTypes,
      (issueType) => issueType.name === QALITY_TEST_ISSUE_TYPE
    );
  },
};
